<template>
  <a-modal
    :title="name"
    :width="500"
    :footer="null"
    @cancel="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
        <a-form-item
          label="店铺名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['name', {rules: [{required: true, message: '店铺名称不能为空！'}],initialValue: formData.name}]" />
        </a-form-item>
        <a-form-item
          label="联系方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['phone', {rules: [{required: true, message: '联系方式不能为空！'}],initialValue: formData.phone}]" />
        </a-form-item>
          <a-form-item
            label="地址"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input v-decorator="['address', {rules: [{required: true, message: '地址不能为空！'}],initialValue: formData.address}]" />
          </a-form-item>
        <a-col align="center" v-if="mode != 'view'" :md="24" :sm="24">
          <a-button @click="handleSubmit" type="primary">提交</a-button>
          <a-button @click="handleCancel" style="margin-left: 10px">取消</a-button>
        </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import fieldRule from '@/utils/field-validate-rules'
  import { postAxios, getAxios } from '@/api/request'
  const formList = {
    name: '',
    userNo: '',
    sex: '',
    remark: '',
    id: ''
  }
  export default {
    name: 'shopAdd',
    data () {
      return {
        // 验证组件
//        fieldRule,
        name: '',
        mode: '',
        formData: { ...formList },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this) // 注册后，才能通过表单拉取数据
      }
    },
    methods: {
      add () {
        this.mode = 'add'
        this.name = '新增店铺'
        this.visible = true
      },
      edit (record) {
        this.mode = 'edit'
        this.name = '编辑店铺'
        this.visible = true
        if (record) {
          this.formData = record
        }
      },
      handleSubmit () {
        this.confirmLoading = true
        this.form.validateFields((err, values) => { // 表单验证
          if (!err) {
            if (this.formData.id) {
              values.id = this.formData.id
            }
            if (this.mode === 'add') {
                console.log(values)
              postAxios('addShop', values).then(res => {
                  if (res.code === '000000') {
                    this.confirmLoading = false
                    this.handleCancel()
                    this.$message.success('新增成功')
                    this.$emit('ok', '') // 成功回调
                  } else {
                    this.$message.error(res.msg)
                  }
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            } else if (this.mode === 'edit') {
              postAxios('editShop', values).then(res => {
                  console.log(res)
                if (res.code === '000000') {
                  this.confirmLoading = false
                  this.handleCancel()
                  this.$message.success('修改成功')
                  this.$emit('ok', '') // 成功回调
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            }
          } else {
            this.confirmLoading = false
          }
        })
      },
      handleCancel () {
        this.visible = false
        this.confirmLoading = false
        this.form.resetFields() // 清空表单
        this.formData = { ...formList }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/shop/modules/shopAdd.vue